import { useQuery } from '@tanstack/react-query';
import { budgetService } from '@services/budget';

export const BUDGET_PROPOSAL_CONVERSATION_QUERY_KEY = 'budget-proposal-conversation';

export const useBudgetProposalConversation = (budgetRequestId: string | undefined) => {
  return useQuery({
    queryKey: [BUDGET_PROPOSAL_CONVERSATION_QUERY_KEY, budgetRequestId],
    queryFn: () => budgetService.getBudgetProposalConversation(budgetRequestId!),
    enabled: !!budgetRequestId,
    staleTime: 2 * 60 * 1000, // 2 minutes for conversations
  });
};